import React from 'react';
import GenericDeleteModal from 'components/UI/V3/Modals/DeleteModal/GenericDeleteModal';
import styles from './DeleteDocument.module.scss';
import { DocumentAttachment } from '@spike/client-model';

export interface DeleteDocumentProps {
    doc: DocumentAttachment;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteDocument: React.FC<DeleteDocumentProps> = ({ doc, onConfirm, onCancel }) => {
    return (
        <GenericDeleteModal
            title={<span className={styles.deleteModalTitle}>Delete File</span>}
            body={
                <p className={styles.deleteModalText}>
                    Are you sure you want to delete <strong>{doc.filename}</strong>?
                </p>
            }
            onConfirm={onConfirm}
            onCancel={onCancel}
            className={styles.deleteModal}
        />
    );
};

export default DeleteDocument;
